import React from "react";
import PropTypes from "prop-types";
import {
  CssBaseline,
  Grid,
  ThemeProvider,
  Paper,
  TextField,
  createTheme,
  InputAdornment,
} from "@material-ui/core";

import { Button, NotificationBar, Typography } from "@invosys/invosys-ui";

import { VpnKeyRounded } from "@material-ui/icons";
import defaultTheme from "../styles/theme";

export default class MFA extends React.Component {
  constructor() {
    super();
    this.notifications = React.createRef();
    this.state = { matches: window.matchMedia("(min-width: 960px)").matches };
  }

  componentDidMount = () => {
    // read from embedded screen if possible
    const fieldErrors = document.getElementById("fieldErrors")?.value || "";
    const actionErrors = document.getElementById("actionErrors")?.value || "";
    const gitVersion = document.getElementById("gitVersion")?.value || "";
    const javascriptCacheDate =
      document.getElementById("javascriptCacheDate")?.value || "";

    const imageUrl = document.getElementById("imageUrl")?.value || "";
    const imageFilename =
      document.getElementById("imageFilename")?.value || "transparent.gif";
    const showLogo = imageFilename !== "transparent.gif";

    const footerText = document.getElementById("footerText")?.value || "";

    const mobilePhone = document.getElementById("mobilePhone")?.value || "";
    const emailAddress = document.getElementById("emailAddress")?.value || "";

    const brandingOverRideText =
      document.getElementById("brandingOverRide")?.value || "{}";
    const brandingOverRide = JSON.parse(
      brandingOverRideText
        .replace(
          /&amp;|&lt;|&gt;|&#39;|&quot;|/g,
          (tag) =>
            ({
              "&amp;": "&",
              "&lt;": "<",
              "&gt;": ">",
              "&#39;": "'",
              "&quot;": '"',
            })[tag] || tag,
        )
        .replaceAll("\n", "{newline}"),
    );

    if (brandingOverRide.primaryColour) {
      defaultTheme.palette.primary.main = brandingOverRide.primaryColour;
    }
    if (brandingOverRide.secondaryColour) {
      defaultTheme.palette.secondary.main = brandingOverRide.secondaryColour;
    }
    if (brandingOverRide.primaryBackgroundColour) {
      defaultTheme.overrides.MuiPaper.root.backgroundColor =
        brandingOverRide.primaryBackgroundColour;
    }
    if (brandingOverRide.secondaryBackgroundColour) {
      defaultTheme.overrides.MuiCssBaseline["@global"].body.backgroundColor =
        brandingOverRide.secondaryBackgroundColour;
    }
    if (brandingOverRide.login_backgroundImage) {
      defaultTheme.overrides.MuiCssBaseline["@global"].body = {
        ...defaultTheme.overrides.MuiCssBaseline["@global"].body,
        backgroundImage: `url(${brandingOverRide.login_backgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        height: "100%",
      };
    }

    this.setState({
      fieldErrors,
      actionErrors,
      gitVersion,
      javascriptCacheDate,
      brandingOverRide,
      theme: createTheme(defaultTheme),
      imageUrl,
      imageFilename,
      showLogo,
      footerText,
      mobilePhone,
      emailAddress,
    });

    // Media breaking
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia("(min-width: 960px)").addEventListener("change", handler);
  };

  addNotification = (message) => {
    this.notifications.current.enqueueNotification(message);
  };

  resendCode = () => {
    this.setState({ resending: true }, () => {
      fetch("/resendcode")
        .then((res) => res.json())
        .then((res) => {
          this.setState({ resending: false }, () => {
            this.addNotification({
              message: res?.response?.description,
              type: res?.response?.status === "OK" ? "info" : "error",
            });
          });
        });
    });
  };

  render = () => {
    return (
      <React.Fragment>
        {this.state.theme && (
          <ThemeProvider theme={this.state.theme}>
            <CssBaseline />

            <Grid
              component={Paper}
              container
              direction="row"
              style={{
                width: "40vw",
                maxWidth: "400px",
                margin: "10vh auto",
                border: "1px solid black",
                borderRadius: "10px",
              }}
            >
              <Grid item sm={12} style={{ padding: "16px" }}>
                {this.state.showLogo ? (
                  <div
                    style={
                      this.state.matches
                        ? { height: "80px", marginBottom: "2em" }
                        : { textAlign: "center" }
                    }
                  >
                    <img
                      style={{ maxWidth: "100%", maxHeight: "80px" }}
                      src={`${this.state.imageUrl}${this.state.imageFilename}`}
                    />
                  </div>
                ) : (
                  <React.Fragment>
                    <Typography variant="h4">Number Manager</Typography>
                    <Typography variant="h6">
                      Multi-Factor Authentication
                    </Typography>
                  </React.Fragment>
                )}
              </Grid>

              <Grid item sm={12} style={{ padding: "16px" }}>
                {this.state.fieldErrors && (
                  <Typography
                    variant="body2"
                    color="error"
                    style={{ marginBottom: "16px" }}
                  >
                    {this.state.fieldErrors.substring(
                      this.state.fieldErrors.indexOf("[") + 1,
                      this.state.fieldErrors.indexOf("]"),
                    )}
                  </Typography>
                )}
                {this.state.actionErrors && (
                  <Typography
                    variant="body2"
                    color="error"
                    style={{ marginBottom: "16px" }}
                  >
                    {this.state.actionErrors.substring(
                      this.state.actionErrors.indexOf("[") + 1,
                      this.state.actionErrors.indexOf("]"),
                    )}
                  </Typography>
                )}
                <form
                  method="post"
                  id="frm_login"
                  action="/verifycode"
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <input type="hidden" name="browserName" id="browserName" />
                  <fieldset style={{ border: "0px" }}>
                    <Typography>{`Please enter the mfa code sent to ${this.state.mobilePhone}${this.state.emailAddress} to complete sign in`}</Typography>
                    <TextField
                      style={{ margin: "0 0 16px 0" }}
                      variant="outlined"
                      size="small"
                      fullWidth
                      type={"text"}
                      name="user.code"
                      id="password"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <VpnKeyRounded color="primary" fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </fieldset>
                  <Grid container>
                    <Grid item xs={12} md={6} style={{ textAlign: "center" }}>
                      <Button
                        color="secondary"
                        variant="outlined"
                        style={{ margin: "16px" }}
                        title="Resend Code"
                        inProgress={this.state.resending}
                        disabled={this.state.verifying || this.state.resending}
                        onClick={() => this.resendCode()}
                      >
                        Resend Code
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={6} style={{ textAlign: "center" }}>
                      <Button
                        id="btn-submit"
                        color="primary"
                        variant="contained"
                        style={{ margin: "16px 0" }}
                        inProgress={this.state.verifying}
                        disabled={this.state.verifying || this.state.resending}
                        onClick={() =>
                          document.getElementById("frm_login").submit()
                        }
                      >
                        Verify Code
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
              <Grid item xs={12} style={{ padding: "0 16px 8px" }}>
                <Typography variant="subtitle2">
                  {this.state.footerText}
                </Typography>
              </Grid>
            </Grid>
            <Typography style={{ textAlign: "center" }} class="hidden">
              {this.state.gitVersion}
            </Typography>
            <Typography style={{ textAlign: "center" }} class="hidden">
              {this.state.javascriptCacheDate}
            </Typography>
            <NotificationBar ref={this.notifications} />
          </ThemeProvider>
        )}
      </React.Fragment>
    );
  };
}

MFA.propTypes = { jwt: PropTypes.string };
